import { Box } from "@chakra-ui/react";
import { FillImage } from "components/images";
import React from "react";
import isoBadge from "../../../public/assets/security-badges/iso-badge.png";
import { type BadgeProps } from "./types";

/**
 * ISO 27001 Certification badge.
 *
 * DO NOT ALTER THE LOGO. There are very strict regulations around it's usage.
 * See more: https://www.notion.so/hightouch/ISO-27001-Certification-189ab9c473d580b7a417ca0d9c9f842e
 */

export function IsoBadge({ backgroundColor, foregroundColor, ...props }: BadgeProps) {
  return (
    <Box
      borderRadius="full"
      bg={backgroundColor}
      display="flex"
      alignItems="center"
      justifyContent="center"
      boxSize="100%"
      {...props}
    >
      <Box boxSize="100%" pos="relative" m="14px">
        <FillImage src={isoBadge} alt="ISO 27001 Certification." style={{ objectFit: "contain" }} />
      </Box>
    </Box>
  );
}
